import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M11.1242 4.03083C11.0484 3.80333 10.85 3.64583 10.6109 3.62833L7.35005 3.38917L6.11338 0.361667C6.02588 0.145833 5.81588 0 5.57671 0C5.33755 0 5.12755 0.145833 5.03421 0.361667L3.80338 3.38917L0.542546 3.62833C0.303379 3.64583 0.105046 3.80333 0.0292123 4.03083C-0.046621 4.25833 0.0292123 4.50333 0.210046 4.655L2.70671 6.76667L1.92505 9.94C1.86671 10.1675 1.95421 10.4125 2.14671 10.5525C2.24588 10.6283 2.36838 10.6633 2.49088 10.6633C2.59588 10.6633 2.70671 10.6342 2.80005 10.5758L5.57671 8.855L8.35338 10.5758C8.55171 10.6983 8.81421 10.6925 9.00088 10.5525C9.19338 10.4125 9.28088 10.1733 9.22255 9.94L8.44088 6.76667L10.9375 4.655C11.1242 4.50333 11.2 4.25833 11.1242 4.03083Z",
];

export function StarIcon(props: IconProps) {
  return (
    <Icon
      paths={PATHS}
      viewBox="0 0 12 11"
      width={12}
      height={11}
      color="currentColor"
      aria-hidden
      {...props}
    />
  );
}
